/**
 * Mobile / tablet clients: AI text-to-SQL requires WebGPU, which is unreliable
 * on typical phone browsers — hide the feature entirely on those clients.
 */
export function shouldShowAiTextToSql(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return true;
  }

  const ua = navigator.userAgent;

  if (
    /Mobi|Android|iP(hone|ad|od)|iOS\)|webOS|BlackBerry|IEMobile|Opera Mini|CriOS|FxiOS|EdgA|EdgiOS|Mobile Safari|SamsungBrowser|UCBrowser|KaiOS|Tablet|Silk|Kindle|PlayBook/i.test(ua)
  ) {
    return false;
  }

  // iPadOS 13+ can report as Macintosh + touch; treat as mobile for this feature.
  const maxTouch = navigator.maxTouchPoints ?? 0;
  if (maxTouch > 1 && /Macintosh/.test(ua) && 'ontouchend' in document) {
    return false;
  }

  return true;
}
